import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './Modal.module.scss';

type HeaderProps = {
  children?: React.ReactNode;
  classNameModifier?: string;
};

const Header: FC<HeaderProps> = ({ children, classNameModifier }) => (
  <div className={getClassNames(styles, 'header', classNameModifier)}>
    {children}
  </div>
);

export default Header;
